import React from "react";
import Modal from "react-modal";
import { LuX } from "react-icons/lu";
import "../styles/LeftPanelPersonal.css";

const ADMIN_UPDATE_REASON = "Admin Update";

export default function PositionChangeModal({
  isOpen,
  onCancel,
  onSave,
  data,
  onChange,
  currentPositionLabel,
  newPositionLabel,
  isSuperAdmin,
  isSaving,
}) {
  const isAdminUpdate = data.reason === ADMIN_UPDATE_REASON;

  const update = (values) => onChange((previous) => ({ ...previous, ...values }));

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => !isSaving && onCancel()}
      shouldCloseOnEsc={!isSaving}
      shouldCloseOnOverlayClick={!isSaving}
      className="position-change-modal"
      overlayClassName="status-overlay"
    >
      <div className="position-change-modal-header">
        <div>
          <h3>Change Primary Position</h3>
          <small>{currentPositionLabel || "Current position"}</small>
          <i className="fa-solid fa-arrow-right" aria-hidden="true" />
          <small>{newPositionLabel || "New position"}</small>
        </div>
        <button
          type="button"
          className="position-change-modal-close"
          onClick={onCancel}
          disabled={isSaving}
          aria-label="Close position change"
        >
          <LuX aria-hidden="true" />
        </button>
      </div>

      <div className="scm-form">
        <section className="position-change-section">
          <div className="position-change-section-title">Previous Position</div>
          <div className="position-change-position-name">
            {currentPositionLabel || "Current position"}
          </div>
          <div className="position-change-date-grid">
            <div className="scm-field">
              <label className="scm-label">Start Date</label>
              <input
                type="date"
                className="scm-input"
                value={data.prev_start_date || ""}
                disabled
              />
            </div>
            {!isAdminUpdate && (
              <div className="scm-field">
                <label className="scm-label">
                  End Date <span className="req">*</span>
                </label>
                <input
                  type="date"
                  className="scm-input"
                  value={data.prev_end_date}
                  onChange={(event) =>
                    update({ prev_end_date: event.target.value })
                  }
                />
              </div>
            )}
          </div>
        </section>

        <section className="position-change-section">
          <div className="position-change-section-title">New Position</div>
          <div className="position-change-position-name">
            {newPositionLabel || "New position"}
          </div>
        <div className="scm-field">
          <label className="scm-label">
            Reason for Change <span className="req">*</span>
          </label>
          <select
            className="scm-input"
            value={data.reason}
            onChange={(event) =>
              update({
                reason: event.target.value,
                create_new_profile: false,
                new_employee_id: "",
                prev_end_date:
                  event.target.value === ADMIN_UPDATE_REASON
                    ? ""
                    : data.prev_end_date,
                new_start_date:
                  event.target.value === ADMIN_UPDATE_REASON
                    ? ""
                    : data.new_start_date,
              })
            }
          >
            <option value="">Select Reason</option>
            <option value="API transfer">API transfer</option>
            <option value="Driver Rebuttal">Driver Rebuttal</option>
            <option value="Transfer">Transfer</option>
            {isSuperAdmin && (
              <option value={ADMIN_UPDATE_REASON}>{ADMIN_UPDATE_REASON}</option>
            )}
          </select>
        </div>

        {!isAdminUpdate && (
          <div className="scm-field">
            <label className="scm-label">
              New Position Start Date <span className="req">*</span>
            </label>
            <input
              type="date"
              className="scm-input"
              value={data.new_start_date}
              onChange={(event) =>
                update({ new_start_date: event.target.value })
              }
            />
          </div>
        )}

        <div className="scm-field">
          <label className="scm-label">Position Change Note</label>
          <textarea
            className="scm-textarea"
            value={data.note}
            onChange={(event) => update({ note: event.target.value })}
          />
        </div>
        </section>
      </div>

      <div className="position-change-modal-actions">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={onCancel}
          disabled={isSaving}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={onSave}
          disabled={isSaving}
        >
          <i className="fa-solid fa-floppy-disk" aria-hidden="true" />
          {isSaving ? "Saving..." : "Save Change"}
        </button>
      </div>
    </Modal>
  );
}
